import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import classPackReducer, { initialState } from '../reducers/classPackReducer';

export const ClassPackContext = createContext();

const ClassPackProvider = ({ children }) => {
  const useClassPackState = useReducer(classPackReducer, initialState);

  return (
    <ClassPackContext.Provider value={[...useClassPackState]}>
      <ContextDevTool
        context={ClassPackContext}
        id="ClassPackContext"
        displayName="ClassPack Context"
      />
      {children}
    </ClassPackContext.Provider>
  );
};

ClassPackProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ClassPackProvider;
